import Vue from "vue";
import Vuex from "vuex";
import user from "@/api/user";
import {getToken} from "@/libs";
import router from "@/router";
import {ipcRenderer} from "electron";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: {}
  },
  getters: {},
  mutations: {
    setUserInfo(state, info) {
      state.userInfo = info;
    }
  },
  actions: {
    getUserInfo({state, commit}) {
      return new Promise((resolve) => {
        user.company_getInfo().then(res => {
          ipcRenderer.invoke('system.user.set', res.data);
          commit('setUserInfo', res.data);
          resolve(res.data);
        })
      })
    },
    handleLogOut({state, commit}) {
      return new Promise((resolve, reject) => {
        user.logout(getToken).then(() => {
          localStorage.clear();
          router.push('/login');
          resolve(true);
        }).catch(err => {
          reject(err)
        })
      })
    }
  },
  modules: {},
});
